export const PNf = () =>{
    return (<>
        <h1>Page not Found</h1>
        </>)
}